export const en = {
  'enum.employmentType.FULL_TIME': 'Full time',
  'enum.employmentType.PART_TIME': 'Part time',
  'enum.employmentType.CONTRACTOR': 'Contractor',
  'enum.payScheme.MONTHLY': 'Monthly salary',
  'enum.payScheme.HOURLY': 'Hourly rate',
  'enum.payScheme.PER_SESSION': 'Per session given',
  'enum.payrollAdjustment.BONUS': 'Bonus',
  'enum.payrollAdjustment.COMMISSION': 'Commission',
  'enum.payrollAdjustment.DEDUCTION': 'Deduction',
  'enum.payrollAdjustment.ADVANCE': 'Advance already paid',
  'team.payPer.MONTHLY': '{amount} / month',
  'team.payPer.HOURLY': '{amount} / hour',
  'team.payPer.PER_SESSION': '{amount} / session',
  'team.department': 'Department',
  'team.noDepartment': 'None',
  'team.position': 'Position',
  'team.firstName': 'First name',
  'team.lastName': 'Last name',
  'team.type': 'Type',
  'team.employment': 'Employment',
  'team.started': 'Started',
  'team.startedOn': 'Started on',
  'team.pay': 'Pay',
  'team.paidBy': 'Paid by',
  'team.amount': 'Amount',
  'team.amountIn': 'Amount ({currency})',
  'team.left': 'Left',
  'team.trainerProfile': 'Trainer profile',
  'team.remove': 'Remove',
  'team.notes': 'Notes',
  'team.personalNumber': 'Personal number',
  'team.month': 'Month',
  'team.gross': 'Gross',
  'team.net': 'Net',
  'team.netToPay': 'Net to pay',
  'team.costToGym': 'Cost to the gym',
  'team.incomeTax': 'Income tax',
  'team.people': 'People',
  'team.paidOn': 'Paid on',
  'team.noPayslips': 'No payslips yet',
  'team.sessionsGiven.one': '{count} session given',
  'team.sessionsGiven.other': '{count} sessions given',
  'team.hours': '{count} hours',
  'employees.title': 'Team',
  'employees.description': 'Everyone the gym employs, with or without a login: the record leave and payroll use.',
  'employees.departments': 'Departments',
  'employees.new': 'New employee',
  'employees.searchLabel': 'Search the team',
  'employees.searchPlaceholder': 'Search name, position or email',
  'employees.allDepartments': 'All departments',
  'employees.filter.active': 'Active',
  'employees.filter.all': 'All',
  'employees.empty': 'Nobody here yet',
  'employees.emptyHint': 'Add the people the gym pays, starting with the staff who already have a login.',
  'employees.linkedTo': 'Linked to',
  'employees.login': 'Login',
  'employees.added': 'Employee added',
  'employees.newDescription': 'Someone with a staff login or a trainer profile can be linked; a cleaner or a guard needs neither.',
  'employees.add': 'Add employee',
  'employees.startFrom': 'Start from',
  'employees.startFromNobody': 'Nobody — type the details',
  'employees.candidate.staff': '{name} · staff login',
  'employees.candidate.staffWithRole': '{name} · staff login ({role})',
  'employees.candidate.trainer': '{name} · trainer profile',
  'employees.positionPlaceholder': 'Receptionist',
  'employees.payOptionalHint': 'Optional now; it can be set on the employee page.',
  'employees.departmentSaved': 'Department saved',
  'employees.departmentRemoved': 'Department removed',
  'employees.departmentsDescription': 'Leave approvals warn when more people of one department would be off at once than it allows.',
  'employees.departmentSummary.one': '{count} person · up to {limit} off at once',
  'employees.departmentSummary.other': '{count} people · up to {limit} off at once',
  'employees.editDepartment': 'Edit {name}',
  'employees.deleteDepartment': 'Delete {name}',
  'employees.nameInGeorgian': 'Name in Georgian',
  'employees.offAtOnce': 'Off at once before a warning',
  'employees.addDepartment': 'Add department',
  'employees.removeDepartmentTitle': 'Remove department?',
  'employees.removeDepartmentDescription': '{name} goes away; its people stay on the team without a department.',
  'employee.backOnTeam': 'Back on the team',
  'employee.backOnTeamDone': 'Back on the team',
  'employee.markLeft': 'Mark as left',
  'employee.markedLeft': 'Marked as left',
  'employee.markLeftTitle': 'Mark {name} as left?',
  'employee.markLeftDescription': 'Their employment ends today unless an end date is already set. Their history, leave and payslips stay.',
  'employee.tab.profile': 'Profile',
  'employee.tab.leave': 'Leave',
  'employee.tab.payslips': 'Payslips',
  'employee.payTerms': 'Pay terms',
  'employee.contactAndRole': 'Contact and role',
  'employee.staffLogin': 'Staff login',
  'employee.noLogin': 'None',
  'employee.branch': 'Branch',
  'employee.branchHint': 'Where someone without a login works. A manager at this branch decides their leave.',
  'employee.everyBranch': 'Every branch',
  'employee.employment': 'Employment',
  'employee.ended': 'Ended',
  'employee.annualLeave': 'Annual leave',
  'employee.annualLeaveDaysExtra': '{days} + {extra} extra',
  'employee.bankAccount': 'Bank account',
  'employee.pensionScheme': 'Pension scheme',
  'employee.pensionYes': 'Participates (2%)',
  'employee.pensionNo': 'Does not participate',
  'employee.currentPay': 'Current pay',
  'employee.pay.saved': 'Pay terms saved',
  'employee.pay.removed': 'Pay terms removed',
  'employee.pay.description': 'Each change starts on a date and closes the one before, so a raise never rewrites a month already paid.',
  'employee.pay.new': 'New pay terms',
  'employee.pay.empty': 'No pay terms yet',
  'employee.pay.emptyHint': 'Set a monthly salary, an hourly rate or a rate per session given.',
  'employee.pay.from': 'From',
  'employee.pay.to': 'To',
  'employee.pay.now': 'Now',
  'employee.pay.hintMonthly': 'Gross, before tax and pension',
  'employee.pay.hintHourly': 'Per hour worked',
  'employee.pay.hintPerSession': 'Per session given: each class taught and each one-to-one session',
  'employee.pay.startingOn': 'Starting on',
  'employee.pay.notePlaceholder': 'Annual review',
  'employee.pay.removeTitle': 'Remove these pay terms?',
  'employee.pay.removeDescription': 'The terms before them run on again with no end date. Use this to correct a mistake, not for a pay cut.',
  'employee.updated': 'Employee updated',
  'employee.editTitle': 'Edit {name}',
  'employee.saveChanges': 'Save changes',
  'employee.endedOn': 'Ended on',
  'employee.annualLeaveField': 'Annual leave (days)',
  'employee.extraDays': 'Extra days',
  'employee.personalNumberHint': '11 digits',
  'employee.bankAccountIban': 'Bank account (IBAN)',
  'employee.pensionLabel': 'Takes part in the funded pension scheme',
  'employee.pensionHint': '2% withheld from gross pay, 2% paid by the gym.',
  'employee.leave.saved': 'Leave types saved',
  'employee.leave.allowance': 'Allowance',
  'employee.leave.allowanceDescription': 'Working days a year from types that use the allowance; a request counts in the year it starts.',
  'employee.leave.leftIn': 'Left in {year}',
  'employee.leave.remaining': '{remaining} of {allowance} days',
  'employee.leave.taken': 'Taken or approved',
  'employee.leave.waiting': 'Waiting for approval',
  'employee.leave.daysPending': '{approved} + {pending} pending days',
  'employee.leave.unpaid': 'unpaid',
  'employee.leave.annualPlusExtra': 'Annual + extra',
  'employee.leave.startingPeriod': 'Starting period',
  'employee.leave.eligibleFrom': 'Eligible from',
  'employee.leave.done': 'Done',
  'employee.leave.typesTitle': 'Leave types this person can request',
  'employee.leave.typesDescription': 'Types everyone can request are ticked unless withheld; the rest are granted one by one.',
  'employee.leave.noTypes': 'No leave types',
  'employee.leave.noTypesHint': 'Add them under Team → Leave settings.',
  'employee.leave.everyone': 'Everyone can request it',
  'employee.leave.oneByOne': 'Granted one by one',
  'employee.leave.switchedOff': 'switched off',
  'employee.leave.undo': 'Undo',
  'employee.leave.history': 'Leave history',
  'employee.leave.noLeave': 'No leave yet',
  'employee.payslips.emptyHint': 'Every payroll this person is on shows here.',
  'employee.payslips.payslip': 'Payslip',
  'employee.payslips.pdfLabel': '{period} payslip as PDF',
  'payroll.title': 'Payroll',
  'payroll.description': 'Monthly pay from pay terms, sessions given, hours and unpaid leave, with income tax and pension. The accountant prepares it; the owner approves it.',
  'payroll.new': 'New payroll',
  'payroll.empty': 'No payroll yet',
  'payroll.emptyHint': 'Start one for a month; everyone employed that month with pay terms gets a line.',
  'payroll.prepared': 'Payroll prepared',
  'payroll.newDescription': 'Everyone employed during the month with pay terms gets a line, computed from their pay terms, sessions given and unpaid leave. Hours and bonuses are added on the lines.',
  'payroll.prepare': 'Prepare payroll',
  'payroll.rates.title': 'Tax and pension rates',
  'payroll.rates.description': "Georgian defaults. Have the gym's accountant confirm them before the first real payroll; a run keeps the rates it was calculated with.",
  'payroll.rates.change': 'Change',
  'payroll.rates.pensionEmployee': 'Pension, employee',
  'payroll.rates.pensionEmployer': 'Pension, employer',
  'payroll.rates.beforeTax': '{rate}, before tax',
  'payroll.rates.payDay': 'Pay day',
  'payroll.rates.payDayValue': '{day} of the next month',
  'payroll.rates.saved': 'Rates saved; recalculate a draft payroll to use them',
  'payroll.rates.dialogDescription': 'In basis points: 2000 is 20%, 200 is 2%.',
  'payroll.rates.incomeTaxBps': 'Income tax (bps)',
  'payroll.rates.payDayHint': 'Day of the month after',
  'payroll.rates.pensionEmployeeBps': 'Pension, employee (bps)',
  'payroll.rates.pensionEmployerBps': 'Pension, employer (bps)',
  'payroll.rates.beforeTaxLabel': 'Employee pension comes off before tax',
  'payroll.rates.beforeTaxHint': "Georgia: tax is charged on gross minus the employee's 2%.",
  'payroll.rates.emailPayslipsLabel': 'Tell staff when their payslip is ready',
  'payroll.rates.emailPayslipsHint': 'When a payroll is marked paid, everyone on it with a login gets a notice in Bulk and an email, in their own language. It says the payslip is ready, never what is on it.',
  'payroll.rates.emailPayslipsOn': 'Staff with a login are told, in the app and by email, when a payroll is paid.',
  'payroll.rates.emailPayslipsOff': 'Staff are not told when a payroll is paid.',
  'payroll.rates.bankFile': 'Bank file',
  'payroll.rates.bankFileHint': 'The file your bank takes for a bulk salary upload, from an approved payroll.',
  'payroll.rates.bankFileSummary': 'Bank file: {bank}',
  'payroll.rates.paymentPurpose': 'Payment purpose',
  'payroll.rates.paymentPurposeHint': 'Shown on each transfer. {month} becomes the payroll month.',
  'payroll.bankFile.NONE': 'None, CSV only',
  'payroll.bankFile.TBC_XML': 'TBC Bank (XML)',
  'payroll.run.bankFile': 'Bank file',
  'payroll.run.recalculated': 'Recalculated from the latest pay terms, leave and sessions',
  'payroll.run.approved': 'Payroll approved',
  'payroll.run.draftDeleted': 'Draft deleted',
  'payroll.run.paidOn': 'Paid on {date}',
  'payroll.run.approvedBy': 'approved by {name}',
  'payroll.run.approvedLocked': 'Approved by {name}; locked until it is reopened.',
  'payroll.run.approvedLockedAnon': 'Approved by an approver; locked until it is reopened.',
  'payroll.run.reopened': 'Reopened: {reason}',
  'payroll.run.draftHint': 'Draft: type hours and bonuses on the lines, recalculate after changing pay terms or leave, then ask the owner to approve.',
  'payroll.run.monthClosed': 'The finance month is closed: this payroll can still be approved and marked paid, and nothing else changes until an owner or admin reopens the month',
  'payroll.run.monthClosedPaid': 'The finance month is closed',
  'payroll.run.allPayslips': 'All payslips',
  'payroll.run.recalculate': 'Recalculate',
  'payroll.run.approve': 'Approve',
  'payroll.run.reopen': 'Reopen',
  'payroll.run.markPaid': 'Mark paid',
  'payroll.run.deleteDraft': 'Delete draft',
  'payroll.run.costHint': 'Gross + employer pension {amount}',
  'payroll.run.details': 'Details',
  'payroll.run.person': 'Person',
  'payroll.run.base': 'Base',
  'payroll.run.pension': 'Pension',
  'payroll.run.tax': 'Tax',
  'payroll.run.howWorkedOut': "How {name}'s pay is worked out",
  'payroll.run.monthDays': '{paid}/{total} days',
  'payroll.run.unpaidLeave': '{count} unpaid leave',
  'payroll.run.editLine': "Edit {name}'s hours and adjustments",
  'payroll.run.hoursAndAdjustments': 'Hours and adjustments',
  'payroll.run.personalNumber': 'Personal number {id}',
  'payroll.run.noPersonalNumber': 'No personal number',
  'payroll.run.noBankAccount': 'No bank account',
  'payroll.run.inPension': 'in the pension scheme',
  'payroll.run.notInPension': 'not in the pension scheme',
  'payroll.run.approveTitle': 'Approve this payroll?',
  'payroll.run.approveDescription.one': '{count} person, {net} net. It is locked once approved; the accountant can then record it paid.',
  'payroll.run.approveDescription.other': '{count} people, {net} net. It is locked once approved; the accountant can then record it paid.',
  'payroll.run.deleteTitle': 'Delete this draft?',
  'payroll.run.deleteDescription': 'The lines go with it; pay terms, leave and sessions are untouched.',
  'payroll.line.saved': '{name}: saved',
  'payroll.line.saveAndRecalculate': 'Save and recalculate',
  'payroll.line.hoursWorked': 'Hours worked this month',
  'payroll.line.adjustments': 'Bonuses, commissions, deductions and advances',
  'payroll.line.kind': 'Kind',
  'payroll.line.whatFor': 'What for',
  'payroll.line.add': 'Add a line',
  'payroll.line.taxNote': 'Bonuses and commissions are taxed with the salary; deductions and advances come off the net.',
  'payroll.reopen.done': 'Payroll reopened as a draft',
  'payroll.reopen.title': 'Reopen this payroll?',
  'payroll.reopen.description': 'It goes back to a draft the accountant can change; the reason is kept.',
  'payroll.reopen.why': 'Why',
  'payroll.paid.done': 'Recorded as paid',
  'payroll.paid.title': 'Record the payment',
  'payroll.paid.description': 'Bulk does not move money; this records when the salaries were transferred.',
  'payroll.paid.noteHint': 'Optional, e.g. the bank transfer reference',
  'payslips.emptyHint': 'Your payslip shows here once the month’s payroll is approved.',
  'payslips.howWorkedOut': 'How {period} was worked out',
  'payslips.unpaidLeaveDays': '{count} unpaid leave days',
  'payslips.paid': 'paid {date}',
  'payslips.taxAndPension': 'Tax and pension',
  'employee.cardHolder': 'Card holder',
  'employee.cardHolderHint': 'The member record whose cards are this person’s. A tap on a staff clock reader then clocks them in or out.',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.employmentType.FULL_TIME': 'სრული განაკვეთი',
  'enum.employmentType.PART_TIME': 'ნახევარი განაკვეთი',
  'enum.employmentType.CONTRACTOR': 'კონტრაქტორი',
  'enum.payScheme.MONTHLY': 'თვიური ხელფასი',
  'enum.payScheme.HOURLY': 'საათობრივი ანაზღაურება',
  'enum.payScheme.PER_SESSION': 'ჩატარებული სესიის მიხედვით',
  'enum.payrollAdjustment.BONUS': 'პრემია',
  'enum.payrollAdjustment.COMMISSION': 'საკომისიო',
  'enum.payrollAdjustment.DEDUCTION': 'დაკავება',
  'enum.payrollAdjustment.ADVANCE': 'უკვე გაცემული ავანსი',
  'team.payPer.MONTHLY': '{amount} / თვე',
  'team.payPer.HOURLY': '{amount} / საათი',
  'team.payPer.PER_SESSION': '{amount} / სესია',
  'team.department': 'განყოფილება',
  'team.noDepartment': 'განყოფილების გარეშე',
  'team.position': 'თანამდებობა',
  'team.firstName': 'სახელი',
  'team.lastName': 'გვარი',
  'team.type': 'ტიპი',
  'team.employment': 'დასაქმების ტიპი',
  'team.started': 'დასაქმდა',
  'team.startedOn': 'დასაქმების თარიღი',
  'team.pay': 'ანაზღაურება',
  'team.paidBy': 'ანაზღაურების წესი',
  'team.amount': 'თანხა',
  'team.amountIn': 'თანხა ({currency})',
  'team.left': 'აღარ მუშაობს',
  'team.trainerProfile': 'ტრენერის პროფილი',
  'team.remove': 'წაშლა',
  'team.notes': 'შენიშვნები',
  'team.personalNumber': 'პირადი ნომერი',
  'team.month': 'თვე',
  'team.gross': 'დარიცხული',
  'team.net': 'ხელზე ასაღები',
  'team.netToPay': 'ხელზე გასაცემი',
  'team.costToGym': 'დარბაზის ხარჯი',
  'team.incomeTax': 'საშემოსავლო გადასახადი',
  'team.people': 'თანამშრომლები',
  'team.paidOn': 'გადახდის თარიღი',
  'team.noPayslips': 'სახელფასო ფურცლები ჯერ არ არის',
  'team.sessionsGiven.one': '{count} ჩატარებული სესია',
  'team.sessionsGiven.other': '{count} ჩატარებული სესია',
  'team.hours': '{count} საათი',
  'employees.title': 'გუნდი',
  'employees.description': 'ყველა, ვინც დარბაზში მუშაობს, სისტემაში ანგარიშით ან მის გარეშე: ამ ჩანაწერს იყენებს შვებულება და ხელფასები.',
  'employees.departments': 'განყოფილებები',
  'employees.new': 'ახალი თანამშრომელი',
  'employees.searchLabel': 'გუნდში ძებნა',
  'employees.searchPlaceholder': 'მოძებნეთ სახელით, თანამდებობით ან ელფოსტით',
  'employees.allDepartments': 'ყველა განყოფილება',
  'employees.filter.active': 'აქტიური',
  'employees.filter.all': 'ყველა',
  'employees.empty': 'აქ ჯერ არავინ არის',
  'employees.emptyHint': 'დაამატეთ ადამიანები, ვისაც დარბაზი უხდის ხელფასს. დაიწყეთ პერსონალით, ვისაც სისტემაში ანგარიში უკვე აქვს.',
  'employees.linkedTo': 'დაკავშირებულია',
  'employees.login': 'ანგარიში',
  'employees.added': 'თანამშრომელი დაემატა',
  'employees.newDescription': 'შეგიძლიათ დააკავშიროთ პერსონალის ანგარიში ან ტრენერის პროფილი; დამლაგებელს ან დაცვის თანამშრომელს არცერთი არ სჭირდება.',
  'employees.add': 'თანამშრომლის დამატება',
  'employees.startFrom': 'შევსება არსებული ჩანაწერიდან',
  'employees.startFromNobody': 'არავინ — შეიყვანეთ მონაცემები ხელით',
  'employees.candidate.staff': '{name} · პერსონალის ანგარიში',
  'employees.candidate.staffWithRole': '{name} · პერსონალის ანგარიში ({role})',
  'employees.candidate.trainer': '{name} · ტრენერის პროფილი',
  'employees.positionPlaceholder': 'მიმღების ადმინისტრატორი',
  'employees.payOptionalHint': 'ახლა არასავალდებულოა; შეგიძლიათ მიუთითოთ თანამშრომლის გვერდზე.',
  'employees.departmentSaved': 'განყოფილება შენახულია',
  'employees.departmentRemoved': 'განყოფილება წაიშალა',
  'employees.departmentsDescription': 'შვებულების დამტკიცებისას გამოჩნდება გაფრთხილება, თუ ერთი განყოფილებიდან ერთდროულად დასაშვებზე მეტი ადამიანი იქნება შვებულებაში.',
  'employees.departmentSummary.one': '{count} ადამიანი · ერთდროულად შვებულებაში მაქსიმუმ {limit}',
  'employees.departmentSummary.other': '{count} ადამიანი · ერთდროულად შვებულებაში მაქსიმუმ {limit}',
  'employees.editDepartment': '{name}: რედაქტირება',
  'employees.deleteDepartment': '{name}: წაშლა',
  'employees.nameInGeorgian': 'სახელი ქართულად',
  'employees.offAtOnce': 'ერთდროულად შვებულებაში, გაფრთხილებამდე',
  'employees.addDepartment': 'განყოფილების დამატება',
  'employees.removeDepartmentTitle': 'წაიშალოს განყოფილება?',
  'employees.removeDepartmentDescription': '„{name}“ წაიშლება; მისი თანამშრომლები გუნდში დარჩებიან განყოფილების გარეშე.',
  'employee.backOnTeam': 'გუნდში დაბრუნება',
  'employee.backOnTeamDone': 'თანამშრომელი გუნდში დაბრუნდა',
  'employee.markLeft': 'წასვლის მონიშვნა',
  'employee.markedLeft': 'მონიშნულია, რომ აღარ მუშაობს',
  'employee.markLeftTitle': 'მოინიშნოს, რომ {name} აღარ მუშაობს?',
  'employee.markLeftDescription': 'დასაქმება დღეს დასრულდება, თუ დასრულების თარიღი უკვე არ არის მითითებული. ისტორია, შვებულებები და სახელფასო ფურცლები შენარჩუნდება.',
  'employee.tab.profile': 'პროფილი',
  'employee.tab.leave': 'შვებულება',
  'employee.tab.payslips': 'სახელფასო ფურცლები',
  'employee.payTerms': 'ანაზღაურების პირობები',
  'employee.contactAndRole': 'კონტაქტი და როლი',
  'employee.staffLogin': 'პერსონალის ანგარიში',
  'employee.noLogin': 'არ აქვს',
  'employee.branch': 'ფილიალი',
  'employee.branchHint': 'სად მუშაობს ადამიანი, რომელსაც ანგარიში არ აქვს. მის შვებულებას ამ ფილიალის მენეჯერი წყვეტს.',
  'employee.everyBranch': 'ყველა ფილიალი',
  'employee.employment': 'დასაქმება',
  'employee.ended': 'დასრულდა',
  'employee.annualLeave': 'ყოველწლიური შვებულება',
  'employee.annualLeaveDaysExtra': '{days} + {extra} დამატებითი',
  'employee.bankAccount': 'საბანკო ანგარიში',
  'employee.pensionScheme': 'საპენსიო სქემა',
  'employee.pensionYes': 'მონაწილეობს (2%)',
  'employee.pensionNo': 'არ მონაწილეობს',
  'employee.currentPay': 'მიმდინარე ანაზღაურება',
  'employee.pay.saved': 'ანაზღაურების პირობები შენახულია',
  'employee.pay.removed': 'ანაზღაურების პირობები წაიშალა',
  'employee.pay.description': 'ყოველი ცვლილება მოქმედებს კონკრეტული თარიღიდან და ხურავს წინას, ამიტომ ხელფასის მომატება უკვე გადახდილ თვეს არ ცვლის.',
  'employee.pay.new': 'ახალი ანაზღაურების პირობები',
  'employee.pay.empty': 'ანაზღაურების პირობები ჯერ არ არის',
  'employee.pay.emptyHint': 'მიუთითეთ თვიური ხელფასი, საათობრივი ანაზღაურება ან ანაზღაურება ჩატარებულ სესიაზე.',
  'employee.pay.from': 'დასაწყისი',
  'employee.pay.to': 'დასასრული',
  'employee.pay.now': 'დღემდე',
  'employee.pay.hintMonthly': 'დარიცხული, გადასახადისა და საპენსიო შენატანის გამოკლებამდე',
  'employee.pay.hintHourly': 'ერთ ნამუშევარ საათზე',
  'employee.pay.hintPerSession': 'ერთ ჩატარებულ სესიაზე: თითოეული ვარჯიში და ინდივიდუალური სესია',
  'employee.pay.startingOn': 'მოქმედებს თარიღიდან',
  'employee.pay.notePlaceholder': 'წლიური გადახედვა',
  'employee.pay.removeTitle': 'წაიშალოს ეს ანაზღაურების პირობები?',
  'employee.pay.removeDescription': 'წინა პირობები კვლავ ამოქმედდება დასრულების თარიღის გარეშე. გამოიყენეთ შეცდომის გასასწორებლად და არა ხელფასის შესამცირებლად.',
  'employee.updated': 'თანამშრომლის მონაცემები განახლდა',
  'employee.editTitle': '{name}: რედაქტირება',
  'employee.saveChanges': 'ცვლილებების შენახვა',
  'employee.endedOn': 'დასრულების თარიღი',
  'employee.annualLeaveField': 'ყოველწლიური შვებულება (დღე)',
  'employee.extraDays': 'დამატებითი დღეები',
  'employee.personalNumberHint': '11 ციფრი',
  'employee.bankAccountIban': 'საბანკო ანგარიში (IBAN)',
  'employee.pensionLabel': 'მონაწილეობს დაგროვებით საპენსიო სქემაში',
  'employee.pensionHint': 'დარიცხული ხელფასიდან 2% ეკავება თანამშრომელს, 2%-ს იხდის დარბაზი.',
  'employee.leave.saved': 'შვებულების ტიპები შენახულია',
  'employee.leave.allowance': 'შვებულების ლიმიტი',
  'employee.leave.allowanceDescription': 'სამუშაო დღეები წელიწადში იმ ტიპებიდან, რომლებიც ლიმიტს იყენებს; მოთხოვნა ითვლება იმ წელს, როდესაც იწყება.',
  'employee.leave.leftIn': 'დარჩენილია {year} წელს',
  'employee.leave.remaining': '{remaining} დღე {allowance}-დან',
  'employee.leave.taken': 'გამოყენებული ან დამტკიცებული',
  'employee.leave.waiting': 'ელოდება დამტკიცებას',
  'employee.leave.daysPending': '{approved} დღე + {pending} მოლოდინში',
  'employee.leave.unpaid': 'უხელფასო',
  'employee.leave.annualPlusExtra': 'ყოველწლიური + დამატებითი',
  'employee.leave.startingPeriod': 'მოსაცდელი პერიოდი',
  'employee.leave.eligibleFrom': 'უფლება ეძლევა',
  'employee.leave.done': 'გავლილია',
  'employee.leave.typesTitle': 'შვებულების ტიპები, რომელთა მოთხოვნაც ამ თანამშრომელს შეუძლია',
  'employee.leave.typesDescription': 'ტიპები, რომლებსაც ყველა ითხოვს, მონიშნულია, თუ არ შეზღუდეთ; დანარჩენი თითოეულს ცალ-ცალკე ენიჭება.',
  'employee.leave.noTypes': 'შვებულების ტიპები არ არის',
  'employee.leave.noTypesHint': 'დაამატეთ აქ: გუნდი → შვებულების წესები.',
  'employee.leave.everyone': 'ყველას შეუძლია მოთხოვნა',
  'employee.leave.oneByOne': 'ენიჭება ინდივიდუალურად',
  'employee.leave.switchedOff': 'გამორთულია',
  'employee.leave.undo': 'ცვლილების გაუქმება',
  'employee.leave.history': 'შვებულებების ისტორია',
  'employee.leave.noLeave': 'შვებულება ჯერ არ ყოფილა',
  'employee.payslips.emptyHint': 'აქ ჩანს ყველა სახელფასო უწყისი, რომელშიც ეს თანამშრომელია.',
  'employee.payslips.payslip': 'სახელფასო ფურცელი',
  'employee.payslips.pdfLabel': '{period} — სახელფასო ფურცელი PDF-ად',
  'payroll.title': 'ხელფასები',
  'payroll.description': 'თვიური ხელფასი ანაზღაურების პირობებიდან, ჩატარებული სესიებიდან, საათებიდან და უხელფასო შვებულებიდან, საშემოსავლო გადასახადითა და საპენსიო შენატანით. ამზადებს ბუღალტერი, ამტკიცებს მფლობელი.',
  'payroll.new': 'ახალი სახელფასო უწყისი',
  'payroll.empty': 'სახელფასო უწყისი ჯერ არ არის',
  'payroll.emptyHint': 'შექმენით უწყისი თვისთვის; ყველა, ვინც იმ თვეში დასაქმებული იყო და აქვს ანაზღაურების პირობები, ცალკე სტრიქონს მიიღებს.',
  'payroll.prepared': 'სახელფასო უწყისი მომზადდა',
  'payroll.newDescription': 'ყველა, ვინც თვის განმავლობაში დასაქმებული იყო და აქვს ანაზღაურების პირობები, მიიღებს სტრიქონს, რომელიც გამოითვლება ანაზღაურების პირობებიდან, ჩატარებული სესიებიდან და უხელფასო შვებულებიდან. საათები და პრემიები სტრიქონებზე ემატება.',
  'payroll.prepare': 'უწყისის მომზადება',
  'payroll.rates.title': 'გადასახადისა და საპენსიო შენატანის განაკვეთები',
  'payroll.rates.description': 'საქართველოში მოქმედი ნაგულისხმევი განაკვეთები. პირველ რეალურ უწყისამდე დაადასტურებინეთ დარბაზის ბუღალტერს; ყოველი უწყისი ინახავს განაკვეთებს, რომლებითაც გამოითვალა.',
  'payroll.rates.change': 'შეცვლა',
  'payroll.rates.pensionEmployee': 'საპენსიო შენატანი (დასაქმებულის)',
  'payroll.rates.pensionEmployer': 'საპენსიო შენატანი (დამსაქმებლის)',
  'payroll.rates.beforeTax': '{rate}, დაბეგვრამდე',
  'payroll.rates.payDay': 'ხელფასის დღე',
  'payroll.rates.payDayValue': 'მომდევნო თვის {day} რიცხვი',
  'payroll.rates.saved': 'განაკვეთები შენახულია; მათ გამოსაყენებლად ხელახლა გამოთვალეთ უწყისის მონახაზი',
  'payroll.rates.dialogDescription': 'საბაზისო პუნქტებში: 2000 არის 20%, 200 არის 2%.',
  'payroll.rates.incomeTaxBps': 'საშემოსავლო გადასახადი (bps)',
  'payroll.rates.payDayHint': 'მომდევნო თვის რიცხვი',
  'payroll.rates.pensionEmployeeBps': 'საპენსიო შენატანი, დასაქმებულის (bps)',
  'payroll.rates.pensionEmployerBps': 'საპენსიო შენატანი, დამსაქმებლის (bps)',
  'payroll.rates.beforeTaxLabel': 'დასაქმებულის საპენსიო შენატანი აკლდება დაბეგვრამდე',
  'payroll.rates.beforeTaxHint': 'საქართველო: გადასახადი ეკისრება დარიცხულს დასაქმებულის 2%-ის გამოკლებით.',
  'payroll.rates.emailPayslipsLabel': 'თანამშრომლებს ეცნობოს, როცა სახელფასო ფურცელი მზადაა',
  'payroll.rates.emailPayslipsHint': 'როცა უწყისი გადახდილად მოინიშნება, მასში შემავალი ყველა თანამშრომელი, ვისაც ანგარიში აქვს, მიიღებს შეტყობინებას Bulk-ში და ელფოსტით, თავის ენაზე. შეტყობინება მხოლოდ ამბობს, რომ ფურცელი მზადაა, და არასდროს — რა წერია მასში.',
  'payroll.rates.emailPayslipsOn': 'ანგარიშის მქონე თანამშრომლებს ხელფასის გადახდისას ეცნობებათ Bulk-ში და ელფოსტით.',
  'payroll.rates.emailPayslipsOff': 'თანამშრომლებს ხელფასის გადახდისას არ ეცნობებათ.',
  'payroll.rates.bankFile': 'ბანკის ფაილი',
  'payroll.rates.bankFileHint': 'ფაილი, რომელსაც თქვენი ბანკი ხელფასების მასობრივი ჩარიცხვისთვის იღებს, დამტკიცებული უწყისიდან.',
  'payroll.rates.bankFileSummary': 'ბანკის ფაილი: {bank}',
  'payroll.rates.paymentPurpose': 'გადახდის დანიშნულება',
  'payroll.rates.paymentPurposeHint': 'ჩანს თითოეულ გადარიცხვაზე. {month} შეიცვლება უწყისის თვით.',
  'payroll.bankFile.NONE': 'არცერთი, მხოლოდ CSV',
  'payroll.bankFile.TBC_XML': 'თიბისი ბანკი (XML)',
  'payroll.run.bankFile': 'ბანკის ფაილი',
  'payroll.run.recalculated': 'ხელახლა გამოითვალა უახლესი ანაზღაურების პირობებით, შვებულებებითა და სესიებით',
  'payroll.run.approved': 'სახელფასო უწყისი დამტკიცდა',
  'payroll.run.draftDeleted': 'მონახაზი წაიშალა',
  'payroll.run.paidOn': 'გადახდილია {date}',
  'payroll.run.approvedBy': 'დაამტკიცა: {name}',
  'payroll.run.approvedLocked': 'დაამტკიცა: {name}; დაბლოკილია, სანამ ხელახლა არ გაიხსნება.',
  'payroll.run.approvedLockedAnon': 'დამტკიცებულია; დაბლოკილია, სანამ ხელახლა არ გაიხსნება.',
  'payroll.run.reopened': 'ხელახლა გაიხსნა: {reason}',
  'payroll.run.draftHint': 'მონახაზი: შეიყვანეთ საათები და პრემიები სტრიქონებზე, ანაზღაურების პირობების ან შვებულების შეცვლის შემდეგ ხელახლა გამოთვალეთ, შემდეგ სთხოვეთ მფლობელს დამტკიცება.',
  'payroll.run.monthClosed': 'ფინანსური თვე დახურულია: ამ ხელფასის დამტკიცება და გადახდილად მონიშვნა ისევ შეიძლება, სხვა არაფერი შეიცვლება, სანამ მფლობელი ან ადმინისტრატორი თვეს ხელახლა არ გახსნის',
  'payroll.run.monthClosedPaid': 'ფინანსური თვე დახურულია',
  'payroll.run.allPayslips': 'ყველა სახელფასო ფურცელი',
  'payroll.run.recalculate': 'ხელახლა გამოთვლა',
  'payroll.run.approve': 'დამტკიცება',
  'payroll.run.reopen': 'ხელახლა გახსნა',
  'payroll.run.markPaid': 'გადახდილად მონიშვნა',
  'payroll.run.deleteDraft': 'მონახაზის წაშლა',
  'payroll.run.costHint': 'დარიცხული + დამსაქმებლის საპენსიო შენატანი {amount}',
  'payroll.run.details': 'დეტალები',
  'payroll.run.person': 'თანამშრომელი',
  'payroll.run.base': 'საბაზო',
  'payroll.run.pension': 'საპენსიო',
  'payroll.run.tax': 'გადასახადი',
  'payroll.run.howWorkedOut': 'ანაზღაურების გაანგარიშება: {name}',
  'payroll.run.monthDays': '{paid}/{total} დღე',
  'payroll.run.unpaidLeave': '{count} დღე უხელფასო შვებულება',
  'payroll.run.editLine': 'საათები და კორექტირებები: {name}',
  'payroll.run.hoursAndAdjustments': 'საათები და კორექტირებები',
  'payroll.run.personalNumber': 'პირადი ნომერი {id}',
  'payroll.run.noPersonalNumber': 'პირადი ნომერი არ არის',
  'payroll.run.noBankAccount': 'საბანკო ანგარიში არ არის',
  'payroll.run.inPension': 'საპენსიო სქემაშია',
  'payroll.run.notInPension': 'საპენსიო სქემაში არ არის',
  'payroll.run.approveTitle': 'დამტკიცდეს ეს სახელფასო უწყისი?',
  'payroll.run.approveDescription.one': '{count} თანამშრომელი, ხელზე ასაღები {net}. დამტკიცების შემდეგ უწყისი იბლოკება; ამის შემდეგ ბუღალტერს შეუძლია გადახდის აღრიცხვა.',
  'payroll.run.approveDescription.other': '{count} თანამშრომელი, ხელზე ასაღები {net}. დამტკიცების შემდეგ უწყისი იბლოკება; ამის შემდეგ ბუღალტერს შეუძლია გადახდის აღრიცხვა.',
  'payroll.run.deleteTitle': 'წაიშალოს ეს მონახაზი?',
  'payroll.run.deleteDescription': 'სტრიქონებიც წაიშლება; ანაზღაურების პირობები, შვებულებები და სესიები უცვლელი რჩება.',
  'payroll.line.saved': '{name}: შენახულია',
  'payroll.line.saveAndRecalculate': 'შენახვა და ხელახლა გამოთვლა',
  'payroll.line.hoursWorked': 'ამ თვეში ნამუშევარი საათები',
  'payroll.line.adjustments': 'პრემიები, საკომისიოები, დაკავებები და ავანსები',
  'payroll.line.kind': 'სახე',
  'payroll.line.whatFor': 'რისთვის',
  'payroll.line.add': 'სტრიქონის დამატება',
  'payroll.line.taxNote': 'პრემიები და საკომისიოები იბეგრება ხელფასთან ერთად; დაკავებები და ავანსები აკლდება ხელზე ასაღებ თანხას.',
  'payroll.reopen.done': 'სახელფასო უწყისი ხელახლა გაიხსნა მონახაზის სახით',
  'payroll.reopen.title': 'გაიხსნას ეს სახელფასო უწყისი ხელახლა?',
  'payroll.reopen.description': 'უწყისი მონახაზად დაბრუნდება და ბუღალტერს მისი შეცვლა შეეძლება; მიზეზი შეინახება.',
  'payroll.reopen.why': 'მიზეზი',
  'payroll.paid.done': 'აღირიცხა როგორც გადახდილი',
  'payroll.paid.title': 'გადახდის აღრიცხვა',
  'payroll.paid.description': 'Bulk ფულს არ გადარიცხავს; აქ აღირიცხება, როდის გადაირიცხა ხელფასები.',
  'payroll.paid.noteHint': 'არასავალდებულო, მაგ. საბანკო გადარიცხვის ნომერი',
  'payslips.emptyHint': 'სახელფასო ფურცელი აქ გამოჩნდება, როცა თვის სახელფასო უწყისი დამტკიცდება.',
  'payslips.howWorkedOut': '{period}: როგორ გამოითვალა',
  'payslips.unpaidLeaveDays': '{count} დღე უხელფასო შვებულება',
  'payslips.paid': 'გადახდილია {date}',
  'payslips.taxAndPension': 'გადასახადი და საპენსიო',
  'employee.cardHolder': 'ბარათის მფლობელი',
  'employee.cardHolderHint': 'წევრის ჩანაწერი, რომლის ბარათებიც ამ თანამშრომელს ეკუთვნის. პერსონალის აღრიცხვის წამკითხველზე შეხება მის მოსვლას ან წასვლას აღრიცხავს.',
};
